import { render, staticRenderFns } from "./Farmer.vue?vue&type=template&id=d862267c&scoped=true&"
import script from "./Farmer.vue?vue&type=script&lang=js&"
export * from "./Farmer.vue?vue&type=script&lang=js&"
import style0 from "./Farmer.vue?vue&type=style&index=0&id=d862267c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d862267c",
  null
  
)

export default component.exports